import SectionHeading from '@/components/feature/SectionHeading';
import { guideSteps, guideNotes } from '@/mocks/home';

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-primary-950 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] uppercase text-accent-400">
            <span className="w-6 h-px bg-accent-400" aria-hidden="true" />
            Guide
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
            追剧指南：四步找到你想看的全部剧集
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200/85 leading-relaxed">
            不管你是从头连看，还是只想跳到高能段落，按下面的顺序走一遍，就能快速建立对整部剧的把握。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {guideSteps.map((g) => (
            <li key={g.step} className="rounded-lg border border-background-100/15 bg-background-50/5 p-5 md:p-6">
              <span className="font-heading text-3xl md:text-4xl font-bold text-accent-400">{g.step}</span>
              <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-background-50">{g.title}</h3>
              <p className="mt-2 text-sm text-background-200/80 leading-relaxed">{g.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-8 rounded-lg border border-background-100/15 bg-background-50/5 p-5 md:p-6">
          <h3 className="flex items-center gap-2 font-heading text-base md:text-lg font-bold text-background-50">
            <i className="ri-lightbulb-flash-line text-accent-400" aria-hidden="true" />
            观看方式与说明
          </h3>
          <ul className="mt-4 space-y-3">
            {guideNotes.map((n) => (
              <li key={n.slice(0, 10)} className="flex items-start gap-2 text-sm text-background-200/85 leading-relaxed">
                <i className="ri-checkbox-circle-line text-accent-400 mt-0.5 shrink-0" aria-hidden="true" />
                {n}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}